import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import actions from "../../../actions/usersListActions";
import axios from "axios";
import swal from "sweetalert";
import CustomPopover from "../../CustomPopover/CustomPopover";
import {
  API_TIMEOUT,
  GET_BANTUAN_TAHUN_KATEGORI,
  GET_BANTUAN,
  GET_BANTUAN_TAHUN,
} from "../../../utils";

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
  DropdownToggle,
  Col,
  Form,
  Row,
  Badge,
  Label,
  FormGroup,
  Input,
  CardBody,
  UncontrolledTooltip,
  Spinner,
} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";

import Widget from "../../Widget/Widget";

import s from "../Users.module.scss";
import { useDispatch } from "react-redux";
import { numberWithCommas } from "../../../utils/func";

import Select, { components } from "react-select";

const { SearchBar } = Search;

const EvaluasiListTable = (props) => {
  const { rows, dispatch, loading, idToDelete, modalOpen } = props;
  const [rowsKu, setRowsKu] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  const [simpleDropdownValue, setSimpleDropdownValue] = useState("");
  const currentYear = new Date().getFullYear();
  const listTahun = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => ({ tahun: 2018 + i })
  ).reverse();
  const [simpleDropdownValue2, setSimpleDropdownValue2] = useState(
    String(currentYear)
  );
  const [bantuan, setBantuan] = useState([]);
  const [currentBantuan, setCurrentBantuan] = useState("");
  const [tahun, setTahun] = useState(String(currentYear));
  const [jumlahPenerimaBantuan, setJumlahPenerimaBantuan] = useState(0);
  const [totalDana, setTotalDana] = useState(0);
  const [totalDesa, setTotalDesa] = useState(0);
  const [nama, setNama] = useState("");
  const [idPenerima, setIdPenerima] = useState("");
  const [catatan, setCatatan] = useState("");
  const [status, setStatus] = useState("");
  const [statusSelect, setStatusSelect] = useState();
  const [modalDelete, setModalDelete] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(true);

  const dispatchKu = useDispatch();

  const changeSelectDropdownSimple = (e) => {
    const select = e.target.value;
    setSimpleDropdownValue(select);
    setCurrentBantuan(select);
  };

  const changeSelectDropdownSimple2 = (e) => {
    const select = e.currentTarget.textContent.trim();
    setSimpleDropdownValue2(select);
    setTahun(select);
    ambilBantuan(select);
  };

  useEffect(() => {
    if (!currentUser) {
      const u = JSON.parse(localStorage.getItem("user"));
      if (u) {
        setCurrentUser(u);
      }
    }
  }, []);

  useEffect(() => {
    if (currentUser && tahun) {
      ambilBantuan(tahun);
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentBantuan && tahun) {
      ambilDataBantuanKategori(currentBantuan, tahun);
    }
  }, [currentBantuan, tahun]);

  const ambilBantuan = (tahunParam) => {
    if (!tahunParam) return;
    setIsLoadingData(true);
    axios({
      method: "post",
      url: GET_BANTUAN_TAHUN,
      timeout: API_TIMEOUT,
      data: { tahun: tahunParam },
    })
      .then((response) => {
        if (response.status !== 200) return;
        const data = response.data?.data ?? [];
        let dataFilter = [];
        if (currentUser?.peran === "admin") {
          dataFilter = data.filter((item) => item.dinas === currentUser.dinas);
        } else {
          dataFilter = data;
        }
        if (dataFilter.length > 0) {
          setSimpleDropdownValue(dataFilter[0].bantuan);
          setCurrentBantuan(dataFilter[0].bantuan);
          setBantuan(dataFilter);
        } else {
          setSimpleDropdownValue("");
          setCurrentBantuan("");
          setBantuan([]);
          setRowsKu([]);
          setJumlahPenerimaBantuan(0);
          setTotalDana(0);
          setTotalDesa(0);
        }
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      })
      .finally(() => setIsLoadingData(false));
  };

  const ambilDataBantuanKategori = (bantuanParam, tahunParam) => {
    if (!bantuanParam || !tahunParam) {
      swal("Info", "Jenis bantuan dan tahun pelaksanaan perlu dipilih", "info");
      return;
    }
    setIsLoadingData(true);
    axios({
      method: "post",
      url: GET_BANTUAN_TAHUN_KATEGORI,
      timeout: API_TIMEOUT,
      data: { bantuan: bantuanParam, tahun: tahunParam },
    })
      .then((response) => {
        if (response.status !== 200) return;
        const data = response.data?.data ?? [];
        setJumlahPenerimaBantuan(data.length);
        const uniqueDesa = new Set(data.map((item) => item.desa).filter(Boolean));
        setTotalDesa(uniqueDesa.size);
        const sumDana = data.reduce((acc, item) => {
          const raw =
            parseFloat(String(item.nilaiUang || 0).replace(/[^\d.-]/g, "")) || 0;
          return acc + raw;
        }, 0);
        setTotalDana(sumDana);
        const mapped = data.map((item, index) => {
          const row = { ...item };
          row.nilaiUang = numberWithCommas(item.nilaiUang);
          row.umur = hitungUmur(item.dob);
          row.nomor = index + 1;
          return row;
        });
        setRowsKu(mapped);
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      })
      .finally(() => setIsLoadingData(false));
  };

  const hitungUmur = (dob) => {
    if (!dob) return "-";
    const startDate = new Date(dob);
    const today = new Date();
    const yearDiff = today.getFullYear() - startDate.getFullYear();
    const monthDiff = today.getMonth() - startDate.getMonth();
    return Math.max(0, Math.ceil((yearDiff * 12 + monthDiff) / 12)) + " thn";
  };

  const handleSimpan = () => {
    axios({
      method: "patch",
      url: GET_BANTUAN + "evaluasi/" + idPenerima,
      timeout: API_TIMEOUT,
      data: { catatan: catatan, status: status },
    })
      .then((response) => {
        if (response.status !== 200) return;
        swal(
          "Sukses",
          "Evaluasi penerima bantuan berhasil disimpan",
          "success"
        );
        ambilDataBantuanKategori(currentBantuan, tahun);
        setModalDelete(false);
      })
      .catch((error) => {
        swal("Error", "Evaluasi penerima bantuan gagal disimpan", "error");
        alert(error?.message || "Terjadi kesalahan");
      });
  };

  const getDataPenerimabantuan = (id) => {
    axios({
      method: "get",
      url: GET_BANTUAN + id,
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) return;
        const data = response.data?.data?.[0];
        if (!data) return;
        setNama(data.nama);
        setStatus(data.status || "");
        const opt = options.find((item) => item.label === data.status);
        setStatusSelect(opt || null);
        setCatatan(data.catatan || "");
      })
      .catch((error) => {
        alert(error?.message || "Gagal mengambil data");
      });
  };

  const openModal = (cell) => {
    setIdPenerima(cell);
    getDataPenerimabantuan(cell);
    setModalDelete(true);
  };

  const closeModal = () => {
    setNama("");
    setStatus("");
    setCatatan("");
    setIdPenerima("");
    setStatusSelect(null);
    setModalDelete(false);
  };

  const actionFormatter = (cell) => (
    <div className="d-flex justify-content-between">
      <Button
        className={s.controlBtn}
        color="primary"
        size="xs"
        onClick={() => openModal(cell)}
      >
        Evaluasi
      </Button>
    </div>
  );

  const statusFormatter = (cell) => (
    <Badge
      color={
        cell === "Hijau"
          ? "success"
          : cell === "Orange"
          ? "warning"
          : cell === "Merah"
          ? "danger"
          : cell === "Hitam"
          ? "secondary"
          : "light"
      }
      className="text-dark"
    >
      {cell || "-"}
    </Badge>
  );

  useEffect(() => {
    dispatch(actions.doFetch({}));
  }, []);

  const options = [
    { value: "Hijau", label: "Hijau", color: "success" },
    { value: "Orange", label: "Orange", color: "warning" },
    { value: "Merah", label: "Merah", color: "danger" },
    { value: "Hitam", label: "Hitam", color: "default" },
  ];

  const OptionComponent = ({ data, ...props }) => (
    <components.Option {...props}>
      <div className={`bullet bullet-${data.color} bullet-sm mr-2`}></div>
      {data.label}
    </components.Option>
  );

  const columns = [
    {
      dataField: "nomor",
      text: "No.",
      sort: true,
      headerStyle: { width: "60px", minWidth: "60px", textAlign: "center" },
      style: { width: "60px", minWidth: "60px" },
    },
    {
      dataField: "nama",
      sort: true,
      text: "Nama",
      headerStyle: { width: "180px", minWidth: "120px" },
      style: { width: "180px", minWidth: "120px" },
      formatter: (cell) => (
        <span style={{ wordBreak: "break-word", display: "block" }}>{cell}</span>
      ),
    },
    {
      dataField: "kelompok",
      sort: true,
      text: "Kelompok",
      headerStyle: { width: "120px", minWidth: "100px" },
      style: { width: "120px", minWidth: "100px" },
    },
    {
      dataField: "bantuan",
      sort: true,
      text: "Bantuan",
      headerStyle: { width: "200px", minWidth: "120px" },
      style: { width: "200px", minWidth: "120px" },
      formatter: (cell) => (
        <span style={{ wordBreak: "break-word", display: "block" }}>{cell}</span>
      ),
    },
    {
      dataField: "nilaiUang",
      sort: true,
      text: "Nilai Uang",
      headerStyle: { width: "120px", minWidth: "120px" },
      style: { width: "120px", minWidth: "120px" },
    },
    {
      dataField: "desa",
      sort: true,
      text: "Desa",
      headerStyle: { width: "140px", minWidth: "120px" },
      style: { width: "140px", minWidth: "120px" },
    },
    {
      dataField: "catatan",
      sort: true,
      text: "Catatan",
      headerStyle: { width: "160px", minWidth: "100px" },
      style: { width: "160px", minWidth: "100px" },
      formatter: (cell) => (
        <span
          style={{
            wordBreak: "break-word",
            display: "block",
            maxWidth: 160,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={cell}
        >
          {cell || "-"}
        </span>
      ),
    },
    {
      dataField: "status",
      sort: true,
      formatter: statusFormatter,
      text: "Status",
      headerStyle: { width: "100px", minWidth: "80px" },
      style: { width: "100px", minWidth: "80px" },
    },
    {
      dataField: "id",
      formatter: actionFormatter,
      text: "Actions",
      headerStyle: { width: "100px", minWidth: "100px" },
      style: { width: "100px", minWidth: "100px" },
    },
  ];

  return (
    <div>
      <Widget className={`widget-p-md ${s.dataLoadingWrap} ${isLoadingData ? s.loading : ""}`}>
        {isLoadingData && (
          <div className={s.dataLoadingOverlay}>
            <Spinner color="primary" />
            <span className={s.dataLoadingText}>Memuat data...</span>
          </div>
        )}
        <Row className="mb-3">
          <Col xs={12}>
            <div
              className={`d-flex flex-wrap align-items-center ${s.summaryChipsWrap}`}
            >
              <span className={s.summaryChip} id="chip-evaluasi-penerima">
                <span className={s.summaryChipLabel}>Jumlah Penerima</span>
                <Badge color="danger" pill className={s.summaryChipValue}>
                  {jumlahPenerimaBantuan}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-evaluasi-penerima">
                Total penerima bantuan berdasarkan bantuan dan tahun yang dipilih
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-evaluasi-dana">
                <span className={s.summaryChipLabel}>Total Dana</span>
                <Badge color="success" pill className={s.summaryChipValue}>
                  Rp {numberWithCommas(totalDana)}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-evaluasi-dana">
                Total nilai uang bantuan yang diterima
              </UncontrolledTooltip>

              <span className={s.summaryChip} id="chip-evaluasi-desa">
                <span className={s.summaryChipLabel}>Sebaran Desa</span>
                <Badge color="primary" pill className={s.summaryChipValue}>
                  {totalDesa}
                </Badge>
              </span>
              <UncontrolledTooltip placement="top" target="chip-evaluasi-desa">
                Jumlah desa asal penerima bantuan
              </UncontrolledTooltip>
            </div>
          </Col>
        </Row>
        <Row className="align-items-end">
          <Col xs={12} sm={6} md={3} lg={2} className="mb-2 mb-md-0">
            <Label for="dropdown-tahun-evaluasi" className="mb-1">
              Tahun
            </Label>
            <UncontrolledButtonDropdown className="d-block">
              <DropdownToggle
                caret
                color="primary"
                id="dropdown-tahun-evaluasi"
                block
              >
                {simpleDropdownValue2}
              </DropdownToggle>
              <UncontrolledTooltip placement="top" target="dropdown-tahun-evaluasi">
                Filter data berdasarkan tahun pelaksanaan
              </UncontrolledTooltip>
              <DropdownMenu>
                {listTahun &&
                  listTahun.map((item) => (
                    <DropdownItem
                      key={item.tahun}
                      onClick={changeSelectDropdownSimple2}
                    >
                      {item.tahun}
                    </DropdownItem>
                  ))}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </Col>
          <Col
            xs={12}
            sm={6}
            md={9}
            lg={10}
            className={`mb-2 mb-md-0 ${s.selectBantuanWrap}`}
          >
            <Label for="select-bantuan-evaluasi" className="mb-1">
              Bantuan
            </Label>
            <Input
              id="select-bantuan-evaluasi"
              type="select"
              value={simpleDropdownValue}
              onChange={changeSelectDropdownSimple}
            >
              <option value="">Pilih Bantuan</option>
              {bantuan &&
                bantuan.map((item, index) => (
                  <option key={`${index}-${item.bantuan}`} value={item.bantuan}>
                    {item.bantuan}
                  </option>
                ))}
            </Input>
            <UncontrolledTooltip placement="top" target="select-bantuan-evaluasi">
              Filter data berdasarkan jenis bantuan
            </UncontrolledTooltip>
          </Col>
        </Row>
        <ToolkitProvider columns={columns} data={rowsKu} keyField="id" search>
          {(props) => (
            <div className={`${s.jenisBantuanTableWrap} ${s.jenisBantuanMinimal}`}>
              <BootstrapTable
                bordered={false}
                classes="table-striped table-hover mt-4"
                pagination={paginationFactory()}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </Widget>

      <Modal size="md" isOpen={modalDelete} toggle={() => closeModal()}>
        <ModalHeader toggle={() => closeModal()}>
          Evaluasi Penerima Bantuan
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <CardBody>
              <Row>
                <Col>
                  <code>{nama}</code>
                </Col>
                <Col>{currentBantuan}</Col>
              </Row>
            </CardBody>
            <Form onSubmit={(e) => e.preventDefault()}>
              <FormGroup row>
                <Label md={3} for="catatan-evaluasi" className="text-md-right">
                  Catatan
                </Label>
                <Col md={9}>
                  <Input
                    rows="4"
                    type="textarea"
                    id="catatan-evaluasi"
                    placeholder="Catatan evaluasi (jika ada)"
                    value={catatan}
                    onChange={(e) => setCatatan(e.target.value)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label md={3} for="status-evaluasi" className="text-md-right">
                  Status
                </Label>
                <Col md={5}>
                  <Select
                    id="status-evaluasi"
                    value={statusSelect}
                    options={options}
                    className="react-select"
                    classNamePrefix="select"
                    isClearable={false}
                    onChange={(data) => {
                      setStatusSelect(data);
                      setStatus(data?.value || "");
                    }}
                    components={{ Option: OptionComponent }}
                  />
                </Col>
                <Col md={4}>
                  <Row className="mb-1">
                    <CustomPopover
                      className={`${s.controlBtn} mx-2`}
                      size="xs"
                      color="success"
                      id="Popover-hijau"
                      placement="top"
                      btnLabel="Hijau"
                      title="Hijau"
                      text="Penerima bantuan memanfaatkan bantuan sesuai dengan ketentuan yang berlaku secara maksimal"
                    />
                    <CustomPopover
                      className={`${s.controlBtn} mx-2`}
                      size="xs"
                      color="warning"
                      id="Popover-orange"
                      placement="top"
                      btnLabel="Orange"
                      title="Orange"
                      text="Penerima bantuan tidak secara maksimal memanfaatkan bantuan sesuai dengan ketentuan yang berlaku"
                    />
                  </Row>
                  <Row>
                    <CustomPopover
                      className={`${s.controlBtn} mx-2`}
                      size="xs"
                      color="danger"
                      id="Popover-merah"
                      placement="top"
                      btnLabel="Merah"
                      title="Merah"
                      text="Penerima bantuan tidak memanfaatkan bantuan dengan baik"
                    />
                    <CustomPopover
                      className={`${s.controlBtn} mx-2`}
                      size="xs"
                      color="default"
                      id="Popover-hitam"
                      placement="top"
                      btnLabel="Hitam"
                      title="Hitam"
                      text="Penerima bantuan menyalahgunakan bantuan. Tidak menunjukkan sikap kooperatif."
                    />
                  </Row>
                </Col>
              </FormGroup>
            </Form>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeModal()}>
            Batal
          </Button>
          <Button color="primary" onClick={() => handleSimpan()}>
            Simpan
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

function mapStateToProps(store) {
  return {
    loading: store.users.list.loading,
    rows: store.users.list.rows,
    modalOpen: store.users.list.modalOpen,
    idToDelete: store.users.list.idToDelete,
  };
}

export default connect(mapStateToProps)(EvaluasiListTable);
